export default __webpack_public_path__ + "static/media/plans.3c84b3ee.svg";